import { Button } from '@mui/material'
import styled from 'styled-components'
import { mainTheme } from '../../../styles/mainTheme'

export const StyledFilterButton = styled(Button)`
  margin-bottom: ${mainTheme.spacing(2)}px;
`
